import { TermsAndConditionsProps } from './TermsAndConditions.props';

import TermsAndConditionsView from './TermsAndConditions.view';

const TermsAndConditionsContainer = (props: TermsAndConditionsProps) => {
  return <TermsAndConditionsView />;
};

export default TermsAndConditionsContainer;
